{
 "_meta": {
  "locale": "bg",
  "status": "partial",
  "note": "Shell translation (draft, needs native review). Missing keys fall back to English."
 },
 "nav": {
  "today": "Сега",
  "people": "Хора",
  "cases": "Преписки",
  "agenda": "Програма",
  "reviews": "Прегледи",
  "prospects": "Проучване",
  "insights": "Анализи",
  "data": "Данни и сигурност",
  "settings": "Настройки",
  "lens": "Лупа"
 },
 "common": {
  "save": "Запази",
  "cancel": "Отказ",
  "close": "Затвори",
  "search": "Търсене",
  "today": "Днес",
  "tomorrow": "Утре",
  "new": "Нов",
  "edit": "Редактирай",
  "delete": "Изтрий"
 },
 "settings": {
  "title": "Настройки",
  "language": "Език",
  "region": "Пазар / регион",
  "theme": "Облик"
 },
 "people": {
  "title": "Хора",
  "new": "Нов човек"
 },
 "today": {
  "agenda_title": "Днес"
 },
 "lens": {
  "placeholder": "Търсете хора, потенциални клиенти, преписки — или въведете команда"
 }
}